import { ProviderBuilder, EGenMode } from '@educraft/base';
import * as MathAddition from './generators/mathAddition';
import * as MathSubtraction from './generators/mathSubtraction';
import * as MathAdditionDigits from './generators/mathAdditionDigits';
import * as MathSubtractionDigits from './generators/mathSubtractionDigits';
import * as MathAdditionSubtraction from './generators/mathAdditionSubtraction';
import * as MathMultiplication from './generators/mathMultiplication';
import * as MathDivision from './generators/mathDivision';
import * as MathEquations from './generators/mathEquations';
import * as MathSpecialized from './generators/mathSpecialized';
import * as MathWordForms from './generators/mathWordForms';
import * as MathOthers from './generators/mathOthers';
import * as MathIvt from './generators/mathIvt';
import * as MathWordProblems from './generators/mathWordProblems';

export function registerGenEq(builder: ProviderBuilder) {
  // Math Addition
  builder.add(EGenMode.GenEq, MathAddition.Math_Addition__To5__Base, 'Eq.Math_Addition__To5__Base');
  builder.add(
    EGenMode.GenEq,
    MathAddition.Math_Addition__To10__Base,
    'Eq.Math_Addition__To10__Base'
  );
  builder.add(
    EGenMode.GenEq,
    MathAddition.Math_Addition__To20__Base,
    'Eq.Math_Addition__To20__Base'
  );
  builder.add(
    EGenMode.GenEq,
    MathAddition.Math_Addition__To20__3Numbers,
    'Eq.Math_Addition__To20__3Numbers'
  );
  builder.add(
    EGenMode.GenEq,
    MathAddition.Math_Addition__To20__4Numbers,
    'Eq.Math_Addition__To20__4Numbers'
  );
  builder.add(
    EGenMode.GenEq,
    MathAddition.Math_Addition__To20__5Numbers,
    'Eq.Math_Addition__To20__5Numbers'
  );
  builder.add(
    EGenMode.GenEq,
    MathAddition.Math_Addition__To20__Carry,
    'Eq.Math_Addition__To20__Carry'
  );
  builder.add(
    EGenMode.GenEq,
    MathAddition.Math_Addition__To100__Base,
    'Eq.Math_Addition__To100__Base'
  );
  builder.add(
    EGenMode.GenEq,
    MathAddition.Math_Addition__To100__3Numbers,
    'Eq.Math_Addition__To100__3Numbers'
  );
  builder.add(
    EGenMode.GenEq,
    MathAddition.Math_Addition__To100__4Numbers,
    'Eq.Math_Addition__To100__4Numbers'
  );
  builder.add(
    EGenMode.GenEq,
    MathAddition.Math_Addition__To100__5Numbers,
    'Eq.Math_Addition__To100__5Numbers'
  );
  builder.add(
    EGenMode.GenEq,
    MathAddition.Math_Addition__To100__Carry,
    'Eq.Math_Addition__To100__Carry'
  );
  builder.add(
    EGenMode.GenEq,
    MathAddition.Math_Addition__To100__NoCarry,
    'Eq.Math_Addition__To100__NoCarry'
  );
  builder.add(
    EGenMode.GenEq,
    MathAddition.Math_Addition__To1000__3Numbers,
    'Eq.Math_Addition__To1000__3Numbers'
  );
  builder.add(
    EGenMode.GenEq,
    MathAddition.Math_Addition__To1000__4Numbers,
    'Eq.Math_Addition__To1000__4Numbers'
  );
  builder.add(
    EGenMode.GenEq,
    MathAddition.Math_Addition__To1000__5Numbers,
    'Eq.Math_Addition__To1000__5Numbers'
  );
  builder.add(
    EGenMode.GenEq,
    MathAddition.Math_Addition__To1000__Carry,
    'Eq.Math_Addition__To1000__Carry'
  );
  builder.add(
    EGenMode.GenEq,
    MathAddition.Math_Addition__To1000__NoCarry,
    'Eq.Math_Addition__To1000__NoCarry'
  );
  builder.add(
    EGenMode.GenEq,
    MathAddition.Math_Addition__To10000__3Numbers,
    'Eq.Math_Addition__To10000__3Numbers'
  );
  builder.add(
    EGenMode.GenEq,
    MathAddition.Math_Addition__To10000__4Numbers,
    'Eq.Math_Addition__To10000__4Numbers'
  );
  builder.add(
    EGenMode.GenEq,
    MathAddition.Math_Addition__To10000__5Numbers,
    'Eq.Math_Addition__To10000__5Numbers'
  );
  builder.add(
    EGenMode.GenEq,
    MathAddition.Math_Addition__To10000__Carry,
    'Eq.Math_Addition__To10000__Carry'
  );
  builder.add(
    EGenMode.GenEq,
    MathAddition.Math_Addition__To10000__NoCarry,
    'Eq.Math_Addition__To10000__NoCarry'
  );
  builder.add(
    EGenMode.GenEq,
    MathAddition.Math_Addition__To1000000__3Numbers,
    'Eq.Math_Addition__To1000000__3Numbers'
  );
  builder.add(
    EGenMode.GenEq,
    MathAddition.Math_Addition__To1000000__4Numbers,
    'Eq.Math_Addition__To1000000__4Numbers'
  );
  builder.add(
    EGenMode.GenEq,
    MathAddition.Math_Addition__To1000000__5Numbers,
    'Eq.Math_Addition__To1000000__5Numbers'
  );
  builder.add(
    EGenMode.GenEq,
    MathAddition.Math_Addition__To1000000__Carry,
    'Eq.Math_Addition__To1000000__Carry'
  );
  builder.add(
    EGenMode.GenEq,
    MathAddition.Math_Addition__To1000000__NoCarry,
    'Eq.Math_Addition__To1000000__NoCarry'
  );

  // Math Subtraction
  builder.add(
    EGenMode.GenEq,
    MathSubtraction.Math_Subtraction__To5__All,
    'Eq.Math_Subtraction__To5__All'
  );
  builder.add(
    EGenMode.GenEq,
    MathSubtraction.Math_Subtraction__To10__All,
    'Eq.Math_Subtraction__To10__All'
  );
  builder.add(
    EGenMode.GenEq,
    MathSubtraction.Math_Subtraction__To20__All,
    'Eq.Math_Subtraction__To20__All'
  );
  builder.add(
    EGenMode.GenEq,
    MathSubtraction.Math_Subtraction__To20__Carry,
    'Eq.Math_Subtraction__To20__Carry'
  );
  builder.add(
    EGenMode.GenEq,
    MathSubtraction.Math_Subtraction__To100__All,
    'Eq.Math_Subtraction__To100__All'
  );
  builder.add(
    EGenMode.GenEq,
    MathSubtraction.Math_Subtraction__To100__Carry,
    'Eq.Math_Subtraction__To100__Carry'
  );
  builder.add(
    EGenMode.GenEq,
    MathSubtraction.Math_Subtraction__To100__NoCarry,
    'Eq.Math_Subtraction__To100__NoCarry'
  );
  builder.add(
    EGenMode.GenEq,
    MathSubtraction.Math_Subtraction__To1000__Carry,
    'Eq.Math_Subtraction__To1000__Carry'
  );
  builder.add(
    EGenMode.GenEq,
    MathSubtraction.Math_Subtraction__To1000__NoCarry,
    'Eq.Math_Subtraction__To1000__NoCarry'
  );
  builder.add(
    EGenMode.GenEq,
    MathSubtraction.Math_Subtraction__To10000__Carry,
    'Eq.Math_Subtraction__To10000__Carry'
  );
  builder.add(
    EGenMode.GenEq,
    MathSubtraction.Math_Subtraction__To1000000__Carry,
    'Eq.Math_Subtraction__To1000000__Carry'
  );
  builder.add(
    EGenMode.GenEq,
    MathSubtraction.Math_Subtraction__To1000000__NoCarry,
    'Eq.Math_Subtraction__To1000000__NoCarry'
  );

  // Math Multiplication
  builder.add(
    EGenMode.GenEq,
    MathMultiplication.Math_Multiplication__1,
    'Eq.Math_Multiplication__1'
  );
  builder.add(
    EGenMode.GenEq,
    MathMultiplication.Math_Multiplication__2,
    'Eq.Math_Multiplication__2'
  );
  builder.add(
    EGenMode.GenEq,
    MathMultiplication.Math_Multiplication__3,
    'Eq.Math_Multiplication__3'
  );
  builder.add(
    EGenMode.GenEq,
    MathMultiplication.Math_Multiplication__4,
    'Eq.Math_Multiplication__4'
  );
  builder.add(
    EGenMode.GenEq,
    MathMultiplication.Math_Multiplication__5,
    'Eq.Math_Multiplication__5'
  );
  builder.add(
    EGenMode.GenEq,
    MathMultiplication.Math_Multiplication__6,
    'Eq.Math_Multiplication__6'
  );
  builder.add(
    EGenMode.GenEq,
    MathMultiplication.Math_Multiplication__7,
    'Eq.Math_Multiplication__7'
  );
  builder.add(
    EGenMode.GenEq,
    MathMultiplication.Math_Multiplication__8,
    'Eq.Math_Multiplication__8'
  );
  builder.add(
    EGenMode.GenEq,
    MathMultiplication.Math_Multiplication__9,
    'Eq.Math_Multiplication__9'
  );
  builder.add(
    EGenMode.GenEq,
    MathMultiplication.Math_Multiplication__10,
    'Eq.Math_Multiplication__10'
  );
  builder.add(
    EGenMode.GenEq,
    MathMultiplication.Math_Multiplication__11,
    'Eq.Math_Multiplication__11'
  );
  builder.add(
    EGenMode.GenEq,
    MathMultiplication.Math_Multiplication__12,
    'Eq.Math_Multiplication__12'
  );
  builder.add(
    EGenMode.GenEq,
    MathMultiplication.Math_Multiplication__13,
    'Eq.Math_Multiplication__13'
  );
  builder.add(
    EGenMode.GenEq,
    MathMultiplication.Math_Multiplication__14,
    'Eq.Math_Multiplication__14'
  );
  builder.add(
    EGenMode.GenEq,
    MathMultiplication.Math_Multiplication__15,
    'Eq.Math_Multiplication__15'
  );

  builder.add(
    EGenMode.GenEq,
    MathMultiplication.Math_Multiplication_TimesTables__All,
    'Eq.Math_Multiplication_TimesTables__All'
  );
  builder.add(
    EGenMode.GenEq,
    MathMultiplication.Math_Multiplication_TimesTables__Harder,
    'Eq.Math_Multiplication_TimesTables__Harder'
  );
  builder.add(
    EGenMode.GenEq,
    MathMultiplication.Math_Multiplication_TimesTables__Mini,
    'Eq.Math_Multiplication_TimesTables__Mini'
  );

  builder.add(
    EGenMode.GenEq,
    MathMultiplication.Math_Multiplication_RepeatedAddition__1,
    'Eq.Math_Multiplication_RepeatedAddition__1'
  );
  builder.add(
    EGenMode.GenEq,
    MathMultiplication.Math_Multiplication_RepeatedAddition__2,
    'Eq.Math_Multiplication_RepeatedAddition__2'
  );
  builder.add(
    EGenMode.GenEq,
    MathMultiplication.Math_Multiplication_RepeatedAddition__3,
    'Eq.Math_Multiplication_RepeatedAddition__3'
  );
  builder.add(
    EGenMode.GenEq,
    MathMultiplication.Math_Multiplication_RepeatedAddition__4,
    'Eq.Math_Multiplication_RepeatedAddition__4'
  );
  builder.add(
    EGenMode.GenEq,
    MathMultiplication.Math_Multiplication_RepeatedAddition__5,
    'Eq.Math_Multiplication_RepeatedAddition__5'
  );
  builder.add(
    EGenMode.GenEq,
    MathMultiplication.Math_Multiplication_RepeatedAddition__6,
    'Eq.Math_Multiplication_RepeatedAddition__6'
  );
  builder.add(
    EGenMode.GenEq,
    MathMultiplication.Math_Multiplication_RepeatedAddition__7,
    'Eq.Math_Multiplication_RepeatedAddition__7'
  );
  builder.add(
    EGenMode.GenEq,
    MathMultiplication.Math_Multiplication_RepeatedAddition__8,
    'Eq.Math_Multiplication_RepeatedAddition__8'
  );
  builder.add(
    EGenMode.GenEq,
    MathMultiplication.Math_Multiplication_RepeatedAddition__9,
    'Eq.Math_Multiplication_RepeatedAddition__9'
  );
  builder.add(
    EGenMode.GenEq,
    MathMultiplication.Math_Multiplication_RepeatedAddition__10,
    'Eq.Math_Multiplication_RepeatedAddition__10'
  );

  builder.add(
    EGenMode.GenEq,
    MathMultiplication.Math_Multiplication_Digits__XXXXXXX__Y,
    'Eq.Math_Multiplication_Digits__XXXXXXX__Y'
  );
  builder.add(
    EGenMode.GenEq,
    MathMultiplication.Math_Multiplication_Digits__XXXXXXX__YY,
    'Eq.Math_Multiplication_Digits__XXXXXXX__YY'
  );
  builder.add(
    EGenMode.GenEq,
    MathMultiplication.Math_Multiplication_Digits__XXXXXXX__YYY,
    'Eq.Math_Multiplication_Digits__XXXXXXX__YYY'
  );
  builder.add(
    EGenMode.GenEq,
    MathMultiplication.Math_Multiplication_Digits__XXXXXXX__YYYY,
    'Eq.Math_Multiplication_Digits__XXXXXXX__YYYY'
  );
  builder.add(
    EGenMode.GenEq,
    MathMultiplication.Math_Multiplication_Digits__XXXXXX__Y,
    'Eq.Math_Multiplication_Digits__XXXXXX__Y'
  );
  builder.add(
    EGenMode.GenEq,
    MathMultiplication.Math_Multiplication_Digits__XXXXXX__YY,
    'Eq.Math_Multiplication_Digits__XXXXXX__YY'
  );
  builder.add(
    EGenMode.GenEq,
    MathMultiplication.Math_Multiplication_Digits__XXXXXX__YYY,
    'Eq.Math_Multiplication_Digits__XXXXXX__YYY'
  );
  builder.add(
    EGenMode.GenEq,
    MathMultiplication.Math_Multiplication_Digits__XXXXXX__YYYY,
    'Eq.Math_Multiplication_Digits__XXXXXX__YYYY'
  );
  builder.add(
    EGenMode.GenEq,
    MathMultiplication.Math_Multiplication_Digits__XXXXX__Y,
    'Eq.Math_Multiplication_Digits__XXXXX__Y'
  );
  builder.add(
    EGenMode.GenEq,
    MathMultiplication.Math_Multiplication_Digits__XXXXX__YY,
    'Eq.Math_Multiplication_Digits__XXXXX__YY'
  );
  builder.add(
    EGenMode.GenEq,
    MathMultiplication.Math_Multiplication_Digits__XXXXX__YYY,
    'Eq.Math_Multiplication_Digits__XXXXX__YYY'
  );
  builder.add(
    EGenMode.GenEq,
    MathMultiplication.Math_Multiplication_Digits__XXXXX__YYYY,
    'Eq.Math_Multiplication_Digits__XXXXX__YYYY'
  );
  builder.add(
    EGenMode.GenEq,
    MathMultiplication.Math_Multiplication_Digits__XXXX__Y,
    'Eq.Math_Multiplication_Digits__XXXX__Y'
  );
  builder.add(
    EGenMode.GenEq,
    MathMultiplication.Math_Multiplication_Digits__XXXX__YY,
    'Eq.Math_Multiplication_Digits__XXXX__YY'
  );
  builder.add(
    EGenMode.GenEq,
    MathMultiplication.Math_Multiplication_Digits__XXXX__YYY,
    'Eq.Math_Multiplication_Digits__XXXX__YYY'
  );
  builder.add(
    EGenMode.GenEq,
    MathMultiplication.Math_Multiplication_Digits__XXXX__YYYY,
    'Eq.Math_Multiplication_Digits__XXXX__YYYY'
  );
  builder.add(
    EGenMode.GenEq,
    MathMultiplication.Math_Multiplication_Digits__XXX__YYYY,
    'Eq.Math_Multiplication_Digits__XXX__YYYY'
  );
  builder.add(
    EGenMode.GenEq,
    MathMultiplication.Math_Multiplication_Digits__XXX__Y,
    'Eq.Math_Multiplication_Digits__XXX__Y'
  );
  builder.add(
    EGenMode.GenEq,
    MathMultiplication.Math_Multiplication_Digits__XXX__YY,
    'Eq.Math_Multiplication_Digits__XXX__YY'
  );
  builder.add(
    EGenMode.GenEq,
    MathMultiplication.Math_Multiplication_Digits__XXX__YYY,
    'Eq.Math_Multiplication_Digits__XXX__YYY'
  );
  builder.add(
    EGenMode.GenEq,
    MathMultiplication.Math_Multiplication_Digits__XX__Y,
    'Eq.Math_Multiplication_Digits__XX__Y'
  );
  builder.add(
    EGenMode.GenEq,
    MathMultiplication.Math_Multiplication_Digits__XX__YY,
    'Eq.Math_Multiplication_Digits__XX__YY'
  );
  builder.add(
    EGenMode.GenEq,
    MathMultiplication.Math_Multiplication_Digits__XX__YYY,
    'Eq.Math_Multiplication_Digits__XX__YYY'
  );
  builder.add(
    EGenMode.GenEq,
    MathMultiplication.Math_Multiplication_Digits__XX__YYYY,
    'Eq.Math_Multiplication_Digits__XX__YYYY'
  );

  // Math Division
  builder.add(EGenMode.GenEq, MathDivision.Math_Division__2, 'Eq.Math_Division__2');
  builder.add(EGenMode.GenEq, MathDivision.Math_Division__3, 'Eq.Math_Division__3');
  builder.add(EGenMode.GenEq, MathDivision.Math_Division__4, 'Eq.Math_Division__4');
  builder.add(EGenMode.GenEq, MathDivision.Math_Division__5, 'Eq.Math_Division__5');
  builder.add(EGenMode.GenEq, MathDivision.Math_Division__6, 'Eq.Math_Division__6');
  builder.add(EGenMode.GenEq, MathDivision.Math_Division__7, 'Eq.Math_Division__7');
  builder.add(EGenMode.GenEq, MathDivision.Math_Division__8, 'Eq.Math_Division__8');
  builder.add(EGenMode.GenEq, MathDivision.Math_Division__9, 'Eq.Math_Division__9');
  builder.add(EGenMode.GenEq, MathDivision.Math_Division__10, 'Eq.Math_Division__10');
  builder.add(EGenMode.GenEq, MathDivision.Math_Division__11, 'Eq.Math_Division__11');
  builder.add(EGenMode.GenEq, MathDivision.Math_Division__12, 'Eq.Math_Division__12');
  builder.add(EGenMode.GenEq, MathDivision.Math_Division__13, 'Eq.Math_Division__13');
  builder.add(EGenMode.GenEq, MathDivision.Math_Division__14, 'Eq.Math_Division__14');
  builder.add(EGenMode.GenEq, MathDivision.Math_Division__15, 'Eq.Math_Division__15');

  builder.add(
    EGenMode.GenEq,
    MathDivision.Math_Division_TimesTables__All,
    'Eq.Math_Division_TimesTables__All'
  );
  builder.add(
    EGenMode.GenEq,
    MathDivision.Math_Division_TimesTables__Harder,
    'Eq.Math_Division_TimesTables__Harder'
  );

  builder.add(
    EGenMode.GenEq,
    MathDivision.Math_Division_Digits__XXXXXXX__Y,
    'Eq.Math_Division_Digits__XXXXXXX__Y'
  );
  builder.add(
    EGenMode.GenEq,
    MathDivision.Math_Division_Digits__XXXXXXX__YY,
    'Eq.Math_Division_Digits__XXXXXXX__YY'
  );
  builder.add(
    EGenMode.GenEq,
    MathDivision.Math_Division_Digits__XXXXXXX__YYY,
    'Eq.Math_Division_Digits__XXXXXXX__YYY'
  );
  builder.add(
    EGenMode.GenEq,
    MathDivision.Math_Division_Digits__XXXXXXX__YYYY,
    'Eq.Math_Division_Digits__XXXXXXX__YYYY'
  );
  builder.add(
    EGenMode.GenEq,
    MathDivision.Math_Division_Digits__XXXXXXX__YYYYY,
    'Eq.Math_Division_Digits__XXXXXXX__YYYYY'
  );
  builder.add(
    EGenMode.GenEq,
    MathDivision.Math_Division_Digits__XXXXXXX__YYYYYY,
    'Eq.Math_Division_Digits__XXXXXXX__YYYYYY'
  );
  builder.add(
    EGenMode.GenEq,
    MathDivision.Math_Division_Digits__XXXXXX__Y,
    'Eq.Math_Division_Digits__XXXXXX__Y'
  );
  builder.add(
    EGenMode.GenEq,
    MathDivision.Math_Division_Digits__XXXXXX__YY,
    'Eq.Math_Division_Digits__XXXXXX__YY'
  );
  builder.add(
    EGenMode.GenEq,
    MathDivision.Math_Division_Digits__XXXXXX__YYY,
    'Eq.Math_Division_Digits__XXXXXX__YYY'
  );
  builder.add(
    EGenMode.GenEq,
    MathDivision.Math_Division_Digits__XXXXXX__YYYY,
    'Eq.Math_Division_Digits__XXXXXX__YYYY'
  );
  builder.add(
    EGenMode.GenEq,
    MathDivision.Math_Division_Digits__XXXXXX__YYYYY,
    'Eq.Math_Division_Digits__XXXXXX__YYYYY'
  );
  builder.add(
    EGenMode.GenEq,
    MathDivision.Math_Division_Digits__XXXXX__Y,
    'Eq.Math_Division_Digits__XXXXX__Y'
  );
  builder.add(
    EGenMode.GenEq,
    MathDivision.Math_Division_Digits__XXXXX__YY,
    'Eq.Math_Division_Digits__XXXXX__YY'
  );
  builder.add(
    EGenMode.GenEq,
    MathDivision.Math_Division_Digits__XXXXX__YYY,
    'Eq.Math_Division_Digits__XXXXX__YYY'
  );
  builder.add(
    EGenMode.GenEq,
    MathDivision.Math_Division_Digits__XXXXX__YYYY,
    'Eq.Math_Division_Digits__XXXXX__YYYY'
  );
  builder.add(
    EGenMode.GenEq,
    MathDivision.Math_Division_Digits__XXXX__Y,
    'Eq.Math_Division_Digits__XXXX__Y'
  );
  builder.add(
    EGenMode.GenEq,
    MathDivision.Math_Division_Digits__XXXX__YY,
    'Eq.Math_Division_Digits__XXXX__YY'
  );
  builder.add(
    EGenMode.GenEq,
    MathDivision.Math_Division_Digits__XXXX__YYY,
    'Eq.Math_Division_Digits__XXXX__YYY'
  );
  builder.add(
    EGenMode.GenEq,
    MathDivision.Math_Division_Digits__XXX__Y,
    'Eq.Math_Division_Digits__XXX__Y'
  );
  builder.add(
    EGenMode.GenEq,
    MathDivision.Math_Division_Digits__XXX__YY,
    'Eq.Math_Division_Digits__XXX__YY'
  );
  builder.add(
    EGenMode.GenEq,
    MathDivision.Math_Division_Digits__XX__Y,
    'Eq.Math_Division_Digits__XX__Y'
  );

  // IVT
  builder.add(EGenMode.GenEq, MathIvt.IVT__Binary__To16, 'Eq.IVT__Binary__To16');
  builder.add(EGenMode.GenEq, MathIvt.IVT__Binary__To256, 'Eq.IVT__Binary__To256');
  builder.add(EGenMode.GenEq, MathIvt.IVT__Hex__To16, 'Eq.IVT__Hex__To16');
  builder.add(EGenMode.GenEq, MathIvt.IVT__Hex__To256, 'Eq.IVT__Hex__To256');

  // Equations
  builder.add(
    EGenMode.GenEq,
    MathEquations.Math_Equation_Addition__To5__Base,
    'Eq.Math_Equation_Addition__To5__Base'
  );
  builder.add(
    EGenMode.GenEq,
    MathEquations.Math_Equation_Addition__To10__Base,
    'Eq.Math_Equation_Addition__To10__Base'
  );
  builder.add(
    EGenMode.GenEq,
    MathEquations.Math_Equation_Addition__To20__Base,
    'Eq.Math_Equation_Addition__To20__Base'
  );
  builder.add(
    EGenMode.GenEq,
    MathEquations.Math_Equation_Addition__To20__3Numbers,
    'Eq.Math_Equation_Addition__To20__3Numbers'
  );
  builder.add(
    EGenMode.GenEq,
    MathEquations.Math_Equation_Addition__To20__Carry,
    'Eq.Math_Equation_Addition__To20__Carry'
  );
  builder.add(
    EGenMode.GenEq,
    MathEquations.Math_Equation_Addition__To100__Base,
    'Eq.Math_Equation_Addition__To100__Base'
  );
  builder.add(
    EGenMode.GenEq,
    MathEquations.Math_Equation_Addition__To100__3Numbers,
    'Eq.Math_Equation_Addition__To100__3Numbers'
  );
  builder.add(
    EGenMode.GenEq,
    MathEquations.Math_Equation_Addition__To100__Carry,
    'Eq.Math_Equation_Addition__To100__Carry'
  );
  builder.add(
    EGenMode.GenEq,
    MathEquations.Math_Equation_Addition__To100__NoCarry,
    'Eq.Math_Equation_Addition__To100__NoCarry'
  );
  builder.add(
    EGenMode.GenEq,
    MathEquations.Math_Equation_Addition__To1000__NoCarry,
    'Eq.Math_Equation_Addition__To1000__NoCarry'
  );
  builder.add(
    EGenMode.GenEq,
    MathEquations.Math_Equation_Addition__To1000000__NoCarry,
    'Eq.Math_Equation_Addition__To1000000__NoCarry'
  );

  builder.add(
    EGenMode.GenEq,
    MathEquations.Math_Equation_Subtraction__To5__Base,
    'Eq.Math_Equation_Subtraction__To5__Base'
  );
  builder.add(
    EGenMode.GenEq,
    MathEquations.Math_Equation_Subtraction__To10__Base,
    'Eq.Math_Equation_Subtraction__To10__Base'
  );
  builder.add(
    EGenMode.GenEq,
    MathEquations.Math_Equation_Subtraction__To20__Base,
    'Eq.Math_Equation_Subtraction__To20__Base'
  );
  builder.add(
    EGenMode.GenEq,
    MathEquations.Math_Equation_Subtraction__To20__Carry,
    'Eq.Math_Equation_Subtraction__To20__Carry'
  );
  builder.add(
    EGenMode.GenEq,
    MathEquations.Math_Equation_Subtraction__To100__Base,
    'Eq.Math_Equation_Subtraction__To100__Base'
  );
  builder.add(
    EGenMode.GenEq,
    MathEquations.Math_Equation_Subtraction__To100__Carry,
    'Eq.Math_Equation_Subtraction__To100__Carry'
  );
  builder.add(
    EGenMode.GenEq,
    MathEquations.Math_Equation_Subtraction__To100__NoCarry,
    'Eq.Math_Equation_Subtraction__To100__NoCarry'
  );
  builder.add(
    EGenMode.GenEq,
    MathEquations.Math_Equation_Subtraction__To1000__NoCarry,
    'Eq.Math_Equation_Subtraction__To1000__NoCarry'
  );
  builder.add(
    EGenMode.GenEq,
    MathEquations.Math_Equation_Subtraction__To1000000__NoCarry,
    'Eq.Math_Equation_Subtraction__To1000000__NoCarry'
  );

  builder.add(EGenMode.GenEq, MathEquations.Math_Equation_Linear__1, 'Eq.Math_Equation_Linear__1');
  builder.add(EGenMode.GenEq, MathEquations.Math_Equation_Linear__2, 'Eq.Math_Equation_Linear__2');

  // Specialized Math
  builder.add(EGenMode.GenEq, MathSpecialized.Math_Log__2__To6, 'Eq.Math_Log__2__To6');
  builder.add(EGenMode.GenEq, MathSpecialized.Math_Log__2__To9, 'Eq.Math_Log__2__To9');
  builder.add(EGenMode.GenEq, MathSpecialized.Math_Log__2__To10, 'Eq.Math_Log__2__To10');
  builder.add(EGenMode.GenEq, MathSpecialized.Math_Log__2__To16, 'Eq.Math_Log__2__To16');
  builder.add(EGenMode.GenEq, MathSpecialized.Math_Log__2__To20, 'Eq.Math_Log__2__To20');
  builder.add(EGenMode.GenEq, MathSpecialized.Math_Log__10__To6, 'Eq.Math_Log__10__To6');
  builder.add(EGenMode.GenEq, MathSpecialized.Math_Log__10__To9, 'Eq.Math_Log__10__To9');

  builder.add(EGenMode.GenEq, MathSpecialized.Math_Power__2X__To5, 'Eq.Math_Power__2X__To5');
  builder.add(EGenMode.GenEq, MathSpecialized.Math_Power__2X__To10, 'Eq.Math_Power__2X__To10');
  builder.add(EGenMode.GenEq, MathSpecialized.Math_Power__2X__To16, 'Eq.Math_Power__2X__To16');
  builder.add(EGenMode.GenEq, MathSpecialized.Math_Power__2X__To20, 'Eq.Math_Power__2X__To20');
  builder.add(EGenMode.GenEq, MathSpecialized.Math_Power__X2__To5, 'Eq.Math_Power__X2__To5');
  builder.add(EGenMode.GenEq, MathSpecialized.Math_Power__X2__To10, 'Eq.Math_Power__X2__To10');
  builder.add(EGenMode.GenEq, MathSpecialized.Math_Power__X2__To16, 'Eq.Math_Power__X2__To16');
  builder.add(EGenMode.GenEq, MathSpecialized.Math_Power__X2__To20, 'Eq.Math_Power__X2__To20');
  builder.add(EGenMode.GenEq, MathSpecialized.Math_Power__X3__To5, 'Eq.Math_Power__X3__To5');
  builder.add(EGenMode.GenEq, MathSpecialized.Math_Power__X3__To10, 'Eq.Math_Power__X3__To10');
  builder.add(EGenMode.GenEq, MathSpecialized.Math_Power__X3__To20, 'Eq.Math_Power__X3__To20');

  builder.add(EGenMode.GenEq, MathSpecialized.Math_SquareRoot__To5, 'Eq.Math_SquareRoot__To5');
  builder.add(EGenMode.GenEq, MathSpecialized.Math_SquareRoot__To10, 'Eq.Math_SquareRoot__To10');
  builder.add(EGenMode.GenEq, MathSpecialized.Math_SquareRoot__To16, 'Eq.Math_SquareRoot__To16');
  builder.add(EGenMode.GenEq, MathSpecialized.Math_SquareRoot__To20, 'Eq.Math_SquareRoot__To20');

  builder.add(
    EGenMode.GenEq,
    MathSpecialized.Math_Percent__To10_Po10__Base,
    'Eq.Math_Percent__To10_Po10__Base'
  );
  builder.add(
    EGenMode.GenEq,
    MathSpecialized.Math_Percent__To10_Po10__Harder,
    'Eq.Math_Percent__To10_Po10__Harder'
  );
  builder.add(
    EGenMode.GenEq,
    MathSpecialized.Math_Percent__To10_Po10__Hardest,
    'Eq.Math_Percent__To10_Po10__Hardest'
  );
  builder.add(
    EGenMode.GenEq,
    MathSpecialized.Math_Percent__To120__Base,
    'Eq.Math_Percent__To120__Base'
  );
  builder.add(
    EGenMode.GenEq,
    MathSpecialized.Math_Percent__To120__Harder,
    'Eq.Math_Percent__To120__Harder'
  );
  builder.add(
    EGenMode.GenEq,
    MathSpecialized.Math_Percent__To120__Hardest,
    'Eq.Math_Percent__To120__Hardest'
  );
  builder.add(
    EGenMode.GenEq,
    MathSpecialized.Math_Percent__To500_Base,
    'Eq.Math_Percent__To500__Base'
  );
  builder.add(
    EGenMode.GenEq,
    MathSpecialized.Math_Percent__To500__Harder,
    'Eq.Math_Percent__To500__Harder'
  );
  builder.add(
    EGenMode.GenEq,
    MathSpecialized.Math_Percent__To500__Hardest,
    'Eq.Math_Percent__To500__Hardest'
  );

  builder.add(
    EGenMode.GenEq,
    MathSpecialized.Math_Rounding__WholeNumber,
    'Eq.Math_Rounding__WholeNumber'
  );
  builder.add(EGenMode.GenEq, MathSpecialized.Math_Rounding__Down, 'Eq.Math_Rounding__Down');
  builder.add(EGenMode.GenEq, MathSpecialized.Math_Rounding__Up, 'Eq.Math_Rounding__Up');

  // Word Forms - Addition
  builder.add(
    EGenMode.GenEq,
    MathWordForms.Math_WordForm_Addition__To5__Base,
    'Eq.Math_WordForm_Addition__To5__Base'
  );
  builder.add(
    EGenMode.GenEq,
    MathWordForms.Math_WordForm_Addition__To10__Base,
    'Eq.Math_WordForm_Addition__To10__Base'
  );
  builder.add(
    EGenMode.GenEq,
    MathWordForms.Math_WordForm_Addition__To20__Base,
    'Eq.Math_WordForm_Addition__To20__Base'
  );
  builder.add(
    EGenMode.GenEq,
    MathWordForms.Math_WordForm_Addition__To20__Carry,
    'Eq.Math_WordForm_Addition__To20__Carry'
  );
  builder.add(
    EGenMode.GenEq,
    MathWordForms.Math_WordForm_Addition__To100__Base,
    'Eq.Math_WordForm_Addition__To100__Base'
  );
  builder.add(
    EGenMode.GenEq,
    MathWordForms.Math_WordForm_Addition__To100__Carry,
    'Eq.Math_WordForm_Addition__To100__Carry'
  );
  builder.add(
    EGenMode.GenEq,
    MathWordForms.Math_WordForm_Addition__To100__NoCarry,
    'Eq.Math_WordForm_Addition__To100__NoCarry'
  );
  builder.add(
    EGenMode.GenEq,
    MathWordForms.Math_WordForm_Addition__To1000__NoCarry,
    'Eq.Math_WordForm_Addition__To1000__NoCarry'
  );
  builder.add(
    EGenMode.GenEq,
    MathWordForms.Math_WordForm_Addition__To1000000__NoCarry,
    'Eq.Math_WordForm_Addition__To1000000__NoCarry'
  );

  builder.add(
    EGenMode.GenEq,
    MathWordForms.Math_WordForm_Subtraction__To5__Base,
    'Eq.Math_WordForm_Subtraction__To5__Base'
  );
  builder.add(
    EGenMode.GenEq,
    MathWordForms.Math_WordForm_Subtraction__To10__Base,
    'Eq.Math_WordForm_Subtraction__To10__Base'
  );
  builder.add(
    EGenMode.GenEq,
    MathWordForms.Math_WordForm_Subtraction__To20__Base,
    'Eq.Math_WordForm_Subtraction__To20__Base'
  );
  builder.add(
    EGenMode.GenEq,
    MathWordForms.Math_WordForm_Subtraction__To20__Carry,
    'Eq.Math_WordForm_Subtraction__To20__Carry'
  );
  builder.add(
    EGenMode.GenEq,
    MathWordForms.Math_WordForm_Subtraction__To100__Base,
    'Eq.Math_WordForm_Subtraction__To100__Base'
  );
  builder.add(
    EGenMode.GenEq,
    MathWordForms.Math_WordForm_Subtraction__To100__Carry,
    'Eq.Math_WordForm_Subtraction__To100__Carry'
  );
  builder.add(
    EGenMode.GenEq,
    MathWordForms.Math_WordForm_Subtraction__To100__NoCarry,
    'Eq.Math_WordForm_Subtraction__To100__NoCarry'
  );
  builder.add(
    EGenMode.GenEq,
    MathWordForms.Math_WordForm_Subtraction__To1000__NoCarry,
    'Eq.Math_WordForm_Subtraction__To1000__NoCarry'
  );
  builder.add(
    EGenMode.GenEq,
    MathWordForms.Math_WordForm_Subtraction__To1000000__NoCarry,
    'Eq.Math_WordForm_Subtraction__To1000000__NoCarry'
  );

  builder.add(
    EGenMode.GenEq,
    MathWordForms.Math_WordForm_Multiplication__1,
    'Eq.Math_WordForm_Multiplication__1'
  );
  builder.add(
    EGenMode.GenEq,
    MathWordForms.Math_WordForm_Multiplication__2,
    'Eq.Math_WordForm_Multiplication__2'
  );
  builder.add(
    EGenMode.GenEq,
    MathWordForms.Math_WordForm_Multiplication__3,
    'Eq.Math_WordForm_Multiplication__3'
  );
  builder.add(
    EGenMode.GenEq,
    MathWordForms.Math_WordForm_Multiplication__4,
    'Eq.Math_WordForm_Multiplication__4'
  );
  builder.add(
    EGenMode.GenEq,
    MathWordForms.Math_WordForm_Multiplication__5,
    'Eq.Math_WordForm_Multiplication__5'
  );
  builder.add(
    EGenMode.GenEq,
    MathWordForms.Math_WordForm_Multiplication__6,
    'Eq.Math_WordForm_Multiplication__6'
  );
  builder.add(
    EGenMode.GenEq,
    MathWordForms.Math_WordForm_Multiplication__7,
    'Eq.Math_WordForm_Multiplication__7'
  );
  builder.add(
    EGenMode.GenEq,
    MathWordForms.Math_WordForm_Multiplication__8,
    'Eq.Math_WordForm_Multiplication__8'
  );
  builder.add(
    EGenMode.GenEq,
    MathWordForms.Math_WordForm_Multiplication__9,
    'Eq.Math_WordForm_Multiplication__9'
  );
  builder.add(
    EGenMode.GenEq,
    MathWordForms.Math_WordForm_Multiplication__10,
    'Eq.Math_WordForm_Multiplication__10'
  );
  builder.add(
    EGenMode.GenEq,
    MathWordForms.Math_WordForm_Multiplication__11,
    'Eq.Math_WordForm_Multiplication__11'
  );
  builder.add(
    EGenMode.GenEq,
    MathWordForms.Math_WordForm_Multiplication__12,
    'Eq.Math_WordForm_Multiplication__12'
  );
  builder.add(
    EGenMode.GenEq,
    MathWordForms.Math_WordForm_Multiplication__13,
    'Eq.Math_WordForm_Multiplication__13'
  );
  builder.add(
    EGenMode.GenEq,
    MathWordForms.Math_WordForm_Multiplication__14,
    'Eq.Math_WordForm_Multiplication__14'
  );
  builder.add(
    EGenMode.GenEq,
    MathWordForms.Math_WordForm_Multiplication__15,
    'Eq.Math_WordForm_Multiplication__15'
  );

  builder.add(
    EGenMode.GenEq,
    MathWordForms.Math_WordForm_Division__2,
    'Eq.Math_WordForm_Division__2'
  );
  builder.add(
    EGenMode.GenEq,
    MathWordForms.Math_WordForm_Division__3,
    'Eq.Math_WordForm_Division__3'
  );
  builder.add(
    EGenMode.GenEq,
    MathWordForms.Math_WordForm_Division__4,
    'Eq.Math_WordForm_Division__4'
  );
  builder.add(
    EGenMode.GenEq,
    MathWordForms.Math_WordForm_Division__5,
    'Eq.Math_WordForm_Division__5'
  );
  builder.add(
    EGenMode.GenEq,
    MathWordForms.Math_WordForm_Division__6,
    'Eq.Math_WordForm_Division__6'
  );
  builder.add(
    EGenMode.GenEq,
    MathWordForms.Math_WordForm_Division__7,
    'Eq.Math_WordForm_Division__7'
  );
  builder.add(
    EGenMode.GenEq,
    MathWordForms.Math_WordForm_Division__8,
    'Eq.Math_WordForm_Division__8'
  );
  builder.add(
    EGenMode.GenEq,
    MathWordForms.Math_WordForm_Division__9,
    'Eq.Math_WordForm_Division__9'
  );
  builder.add(
    EGenMode.GenEq,
    MathWordForms.Math_WordForm_Division__10,
    'Eq.Math_WordForm_Division__10'
  );
  builder.add(
    EGenMode.GenEq,
    MathWordForms.Math_WordForm_Division__11,
    'Eq.Math_WordForm_Division__11'
  );
  builder.add(
    EGenMode.GenEq,
    MathWordForms.Math_WordForm_Division__12,
    'Eq.Math_WordForm_Division__12'
  );
  builder.add(
    EGenMode.GenEq,
    MathWordForms.Math_WordForm_Division__13,
    'Eq.Math_WordForm_Division__13'
  );
  builder.add(
    EGenMode.GenEq,
    MathWordForms.Math_WordForm_Division__14,
    'Eq.Math_WordForm_Division__14'
  );
  builder.add(
    EGenMode.GenEq,
    MathWordForms.Math_WordForm_Division__15,
    'Eq.Math_WordForm_Division__15'
  );

  builder.add(
    EGenMode.GenEq,
    MathWordForms.Math_WordForm_Multiplication_TimesTables__All,
    'Eq.Math_WordForm_Multiplication_TimesTables__All'
  );
  builder.add(
    EGenMode.GenEq,
    MathWordForms.Math_WordForm_Multiplication_TimesTables__Harder,
    'Eq.Math_WordForm_Multiplication_TimesTables__Harder'
  );
  builder.add(
    EGenMode.GenEq,
    MathWordForms.Math_WordForm_Multiplication_TimesTables__Mini,
    'Eq.Math_WordForm_Multiplication_TimesTables__Mini'
  );
  builder.add(
    EGenMode.GenEq,
    MathWordForms.Math_WordForm_Division_TimesTables__All,
    'Eq.Math_WordForm_Division_TimesTables__All'
  );
  builder.add(
    EGenMode.GenEq,
    MathWordForms.Math_WordForm_Division_TimesTables__Harder,
    'Eq.Math_WordForm_Division_TimesTables__Harder'
  );

  // Others
  builder.add(
    EGenMode.GenEq,
    MathOthers.Math_Brackets__PlusMinus_MultiplicationDivision,
    'Eq.Math_Brackets__PlusMinus_MultiplicationDivision'
  );
  builder.add(
    EGenMode.GenEq,
    MathOthers.Math_Numbers_English__To10,
    'Eq.Math_Numbers_English__To10'
  );
  builder.add(
    EGenMode.GenEq,
    MathOthers.Math_Numbers_English__To20,
    'Eq.Math_Numbers_English__To20'
  );
  builder.add(
    EGenMode.GenEq,
    MathOthers.Math_Numbers_English__To100,
    'Eq.Math_Numbers_English__To100'
  );
  builder.add(
    EGenMode.GenEq,
    MathOthers.Math_Numbers_English__To1000,
    'Eq.Math_Numbers_English__To1000'
  );
  builder.add(
    EGenMode.GenEq,
    MathOthers.Math_Numbers_English__To1000000,
    'Eq.Math_Numbers_English__To1000000'
  );
  builder.add(EGenMode.GenEq, MathOthers.Math_Numbers_Roman__To20, 'Eq.Math_Numbers_Roman__To20');
  builder.add(EGenMode.GenEq, MathOthers.Math_Numbers_Roman__To100, 'Eq.Math_Numbers_Roman__To100');
  builder.add(
    EGenMode.GenEq,
    MathOthers.Math_Numbers_Roman__To1000,
    'Eq.Math_Numbers_Roman__To1000'
  );
  builder.add(
    EGenMode.GenEq,
    MathOthers.Math_Numbers_Roman__To2000,
    'Eq.Math_Numbers_Roman__To2000'
  );

  builder.add(
    EGenMode.GenEq,
    MathAdditionSubtraction.Math_Addition_Subtraction__To1000__3Numbers,
    'Eq.Math_Addition_Subtraction__To1000__3Numbers'
  );
  builder.add(
    EGenMode.GenEq,
    MathAdditionSubtraction.Math_Addition_Subtraction__To1000__4Numbers,
    'Eq.Math_Addition_Subtraction__To1000__4Numbers'
  );
  builder.add(
    EGenMode.GenEq,
    MathAdditionSubtraction.Math_Addition_Subtraction__To1000__5Numbers,
    'Eq.Math_Addition_Subtraction__To1000__5Numbers'
  );
  builder.add(
    EGenMode.GenEq,
    MathAdditionSubtraction.Math_Addition_Subtraction__To100__3Numbers,
    'Eq.Math_Addition_Subtraction__To100__3Numbers'
  );
  builder.add(
    EGenMode.GenEq,
    MathAdditionSubtraction.Math_Addition_Subtraction__To100__4Numbers,
    'Eq.Math_Addition_Subtraction__To100__4Numbers'
  );
  builder.add(
    EGenMode.GenEq,
    MathAdditionSubtraction.Math_Addition_Subtraction__To100__5Numbers,
    'Eq.Math_Addition_Subtraction__To100__5Numbers'
  );
  builder.add(
    EGenMode.GenEq,
    MathAdditionSubtraction.Math_Addition_Subtraction__To20__3Numbers,
    'Eq.Math_Addition_Subtraction__To20__3Numbers'
  );
  builder.add(
    EGenMode.GenEq,
    MathAdditionSubtraction.Math_Addition_Subtraction__To20__4Numbers,
    'Eq.Math_Addition_Subtraction__To20__4Numbers'
  );
  builder.add(
    EGenMode.GenEq,
    MathAdditionSubtraction.Math_Addition_Subtraction__To20__5Numbers,
    'Eq.Math_Addition_Subtraction__To20__5Numbers'
  );

  builder.add(EGenMode.GenEq, MathWordProblems.Math_WordProblem__2A, 'Eq.Math_WordProblem__2A');
  builder.add(EGenMode.GenEq, MathWordProblems.Math_WordProblem__2B, 'Eq.Math_WordProblem__2B');

  // Math Addition Digits
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__CarryAny__XX__Y, 'Eq.Math_Addition_Digits__CarryAny__XX__Y');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__CarryAny__XXX__Y, 'Eq.Math_Addition_Digits__CarryAny__XXX__Y');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__CarryAny__XXXX__Y, 'Eq.Math_Addition_Digits__CarryAny__XXXX__Y');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__CarryAny__XXXXX__Y, 'Eq.Math_Addition_Digits__CarryAny__XXXXX__Y');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__CarryAny__XXXXXX__Y, 'Eq.Math_Addition_Digits__CarryAny__XXXXXX__Y');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__CarryAny__X__YY, 'Eq.Math_Addition_Digits__CarryAny__X__YY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__CarryAny__XX__YY, 'Eq.Math_Addition_Digits__CarryAny__XX__YY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__CarryAny__XXX__YY, 'Eq.Math_Addition_Digits__CarryAny__XXX__YY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__CarryAny__XXXX__YY, 'Eq.Math_Addition_Digits__CarryAny__XXXX__YY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__CarryAny__XXXXX__YY, 'Eq.Math_Addition_Digits__CarryAny__XXXXX__YY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__CarryAny__XXXXXX__YY, 'Eq.Math_Addition_Digits__CarryAny__XXXXXX__YY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__CarryAny__X__YYY, 'Eq.Math_Addition_Digits__CarryAny__X__YYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__CarryAny__XX__YYY, 'Eq.Math_Addition_Digits__CarryAny__XX__YYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__CarryAny__XXX__YYY, 'Eq.Math_Addition_Digits__CarryAny__XXX__YYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__CarryAny__XXXX__YYY, 'Eq.Math_Addition_Digits__CarryAny__XXXX__YYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__CarryAny__XXXXX__YYY, 'Eq.Math_Addition_Digits__CarryAny__XXXXX__YYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__CarryAny__XXXXXX__YYY, 'Eq.Math_Addition_Digits__CarryAny__XXXXXX__YYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__CarryAny__X__YYYY, 'Eq.Math_Addition_Digits__CarryAny__X__YYYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__CarryAny__XX__YYYY, 'Eq.Math_Addition_Digits__CarryAny__XX__YYYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__CarryAny__XXX__YYYY, 'Eq.Math_Addition_Digits__CarryAny__XXX__YYYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__CarryAny__XXXX__YYYY, 'Eq.Math_Addition_Digits__CarryAny__XXXX__YYYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__CarryAny__XXXXX__YYYY, 'Eq.Math_Addition_Digits__CarryAny__XXXXX__YYYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__CarryAny__XXXXXX__YYYY, 'Eq.Math_Addition_Digits__CarryAny__XXXXXX__YYYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__CarryAny__X__YYYYY, 'Eq.Math_Addition_Digits__CarryAny__X__YYYYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__CarryAny__XX__YYYYY, 'Eq.Math_Addition_Digits__CarryAny__XX__YYYYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__CarryAny__XXX__YYYYY, 'Eq.Math_Addition_Digits__CarryAny__XXX__YYYYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__CarryAny__XXXX__YYYYY, 'Eq.Math_Addition_Digits__CarryAny__XXXX__YYYYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__CarryAny__XXXXX__YYYYY, 'Eq.Math_Addition_Digits__CarryAny__XXXXX__YYYYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__CarryAny__XXXXXX__YYYYY, 'Eq.Math_Addition_Digits__CarryAny__XXXXXX__YYYYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__CarryAny__X__YYYYYY, 'Eq.Math_Addition_Digits__CarryAny__X__YYYYYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__CarryAny__XX__YYYYYY, 'Eq.Math_Addition_Digits__CarryAny__XX__YYYYYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__CarryAny__XXX__YYYYYY, 'Eq.Math_Addition_Digits__CarryAny__XXX__YYYYYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__CarryAny__XXXX__YYYYYY, 'Eq.Math_Addition_Digits__CarryAny__XXXX__YYYYYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__CarryAny__XXXXX__YYYYYY, 'Eq.Math_Addition_Digits__CarryAny__XXXXX__YYYYYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__CarryAny__XXXXXX__YYYYYY, 'Eq.Math_Addition_Digits__CarryAny__XXXXXX__YYYYYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__CarryAll__XX__Y, 'Eq.Math_Addition_Digits__CarryAll__XX__Y');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__CarryAll__XXX__Y, 'Eq.Math_Addition_Digits__CarryAll__XXX__Y');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__CarryAll__XXXX__Y, 'Eq.Math_Addition_Digits__CarryAll__XXXX__Y');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__CarryAll__XXXXX__Y, 'Eq.Math_Addition_Digits__CarryAll__XXXXX__Y');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__CarryAll__XXXXXX__Y, 'Eq.Math_Addition_Digits__CarryAll__XXXXXX__Y');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__CarryAll__X__YY, 'Eq.Math_Addition_Digits__CarryAll__X__YY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__CarryAll__XX__YY, 'Eq.Math_Addition_Digits__CarryAll__XX__YY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__CarryAll__XXX__YY, 'Eq.Math_Addition_Digits__CarryAll__XXX__YY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__CarryAll__XXXX__YY, 'Eq.Math_Addition_Digits__CarryAll__XXXX__YY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__CarryAll__XXXXX__YY, 'Eq.Math_Addition_Digits__CarryAll__XXXXX__YY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__CarryAll__XXXXXX__YY, 'Eq.Math_Addition_Digits__CarryAll__XXXXXX__YY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__CarryAll__X__YYY, 'Eq.Math_Addition_Digits__CarryAll__X__YYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__CarryAll__XX__YYY, 'Eq.Math_Addition_Digits__CarryAll__XX__YYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__CarryAll__XXX__YYY, 'Eq.Math_Addition_Digits__CarryAll__XXX__YYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__CarryAll__XXXX__YYY, 'Eq.Math_Addition_Digits__CarryAll__XXXX__YYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__CarryAll__XXXXX__YYY, 'Eq.Math_Addition_Digits__CarryAll__XXXXX__YYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__CarryAll__XXXXXX__YYY, 'Eq.Math_Addition_Digits__CarryAll__XXXXXX__YYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__CarryAll__X__YYYY, 'Eq.Math_Addition_Digits__CarryAll__X__YYYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__CarryAll__XX__YYYY, 'Eq.Math_Addition_Digits__CarryAll__XX__YYYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__CarryAll__XXX__YYYY, 'Eq.Math_Addition_Digits__CarryAll__XXX__YYYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__CarryAll__XXXX__YYYY, 'Eq.Math_Addition_Digits__CarryAll__XXXX__YYYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__CarryAll__XXXXX__YYYY, 'Eq.Math_Addition_Digits__CarryAll__XXXXX__YYYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__CarryAll__XXXXXX__YYYY, 'Eq.Math_Addition_Digits__CarryAll__XXXXXX__YYYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__CarryAll__X__YYYYY, 'Eq.Math_Addition_Digits__CarryAll__X__YYYYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__CarryAll__XX__YYYYY, 'Eq.Math_Addition_Digits__CarryAll__XX__YYYYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__CarryAll__XXX__YYYYY, 'Eq.Math_Addition_Digits__CarryAll__XXX__YYYYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__CarryAll__XXXX__YYYYY, 'Eq.Math_Addition_Digits__CarryAll__XXXX__YYYYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__CarryAll__XXXXX__YYYYY, 'Eq.Math_Addition_Digits__CarryAll__XXXXX__YYYYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__CarryAll__XXXXXX__YYYYY, 'Eq.Math_Addition_Digits__CarryAll__XXXXXX__YYYYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__CarryAll__X__YYYYYY, 'Eq.Math_Addition_Digits__CarryAll__X__YYYYYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__CarryAll__XX__YYYYYY, 'Eq.Math_Addition_Digits__CarryAll__XX__YYYYYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__CarryAll__XXX__YYYYYY, 'Eq.Math_Addition_Digits__CarryAll__XXX__YYYYYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__CarryAll__XXXX__YYYYYY, 'Eq.Math_Addition_Digits__CarryAll__XXXX__YYYYYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__CarryAll__XXXXX__YYYYYY, 'Eq.Math_Addition_Digits__CarryAll__XXXXX__YYYYYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__CarryAll__XXXXXX__YYYYYY, 'Eq.Math_Addition_Digits__CarryAll__XXXXXX__YYYYYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__WithoutCarry__XX__Y, 'Eq.Math_Addition_Digits__WithoutCarry__XX__Y');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__WithoutCarry__XXX__Y, 'Eq.Math_Addition_Digits__WithoutCarry__XXX__Y');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__WithoutCarry__XXXX__Y, 'Eq.Math_Addition_Digits__WithoutCarry__XXXX__Y');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__WithoutCarry__XXXXX__Y, 'Eq.Math_Addition_Digits__WithoutCarry__XXXXX__Y');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__WithoutCarry__XXXXXX__Y, 'Eq.Math_Addition_Digits__WithoutCarry__XXXXXX__Y');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__WithoutCarry__X__YY, 'Eq.Math_Addition_Digits__WithoutCarry__X__YY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__WithoutCarry__XX__YY, 'Eq.Math_Addition_Digits__WithoutCarry__XX__YY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__WithoutCarry__XXX__YY, 'Eq.Math_Addition_Digits__WithoutCarry__XXX__YY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__WithoutCarry__XXXX__YY, 'Eq.Math_Addition_Digits__WithoutCarry__XXXX__YY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__WithoutCarry__XXXXX__YY, 'Eq.Math_Addition_Digits__WithoutCarry__XXXXX__YY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__WithoutCarry__XXXXXX__YY, 'Eq.Math_Addition_Digits__WithoutCarry__XXXXXX__YY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__WithoutCarry__X__YYY, 'Eq.Math_Addition_Digits__WithoutCarry__X__YYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__WithoutCarry__XX__YYY, 'Eq.Math_Addition_Digits__WithoutCarry__XX__YYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__WithoutCarry__XXX__YYY, 'Eq.Math_Addition_Digits__WithoutCarry__XXX__YYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__WithoutCarry__XXXX__YYY, 'Eq.Math_Addition_Digits__WithoutCarry__XXXX__YYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__WithoutCarry__XXXXX__YYY, 'Eq.Math_Addition_Digits__WithoutCarry__XXXXX__YYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__WithoutCarry__XXXXXX__YYY, 'Eq.Math_Addition_Digits__WithoutCarry__XXXXXX__YYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__WithoutCarry__X__YYYY, 'Eq.Math_Addition_Digits__WithoutCarry__X__YYYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__WithoutCarry__XX__YYYY, 'Eq.Math_Addition_Digits__WithoutCarry__XX__YYYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__WithoutCarry__XXX__YYYY, 'Eq.Math_Addition_Digits__WithoutCarry__XXX__YYYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__WithoutCarry__XXXX__YYYY, 'Eq.Math_Addition_Digits__WithoutCarry__XXXX__YYYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__WithoutCarry__XXXXX__YYYY, 'Eq.Math_Addition_Digits__WithoutCarry__XXXXX__YYYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__WithoutCarry__XXXXXX__YYYY, 'Eq.Math_Addition_Digits__WithoutCarry__XXXXXX__YYYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__WithoutCarry__X__YYYYY, 'Eq.Math_Addition_Digits__WithoutCarry__X__YYYYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__WithoutCarry__XX__YYYYY, 'Eq.Math_Addition_Digits__WithoutCarry__XX__YYYYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__WithoutCarry__XXX__YYYYY, 'Eq.Math_Addition_Digits__WithoutCarry__XXX__YYYYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__WithoutCarry__XXXX__YYYYY, 'Eq.Math_Addition_Digits__WithoutCarry__XXXX__YYYYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__WithoutCarry__XXXXX__YYYYY, 'Eq.Math_Addition_Digits__WithoutCarry__XXXXX__YYYYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__WithoutCarry__XXXXXX__YYYYY, 'Eq.Math_Addition_Digits__WithoutCarry__XXXXXX__YYYYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__WithoutCarry__X__YYYYYY, 'Eq.Math_Addition_Digits__WithoutCarry__X__YYYYYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__WithoutCarry__XX__YYYYYY, 'Eq.Math_Addition_Digits__WithoutCarry__XX__YYYYYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__WithoutCarry__XXX__YYYYYY, 'Eq.Math_Addition_Digits__WithoutCarry__XXX__YYYYYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__WithoutCarry__XXXX__YYYYYY, 'Eq.Math_Addition_Digits__WithoutCarry__XXXX__YYYYYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__WithoutCarry__XXXXX__YYYYYY, 'Eq.Math_Addition_Digits__WithoutCarry__XXXXX__YYYYYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__WithoutCarry__XXXXXX__YYYYYY, 'Eq.Math_Addition_Digits__WithoutCarry__XXXXXX__YYYYYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__Carry1__XX__Y, 'Eq.Math_Addition_Digits__Carry1__XX__Y');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__Carry1__XXX__Y, 'Eq.Math_Addition_Digits__Carry1__XXX__Y');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__Carry1__XXXX__Y, 'Eq.Math_Addition_Digits__Carry1__XXXX__Y');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__Carry1__XXXXX__Y, 'Eq.Math_Addition_Digits__Carry1__XXXXX__Y');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__Carry1__XXXXXX__Y, 'Eq.Math_Addition_Digits__Carry1__XXXXXX__Y');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__Carry1__X__YY, 'Eq.Math_Addition_Digits__Carry1__X__YY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__Carry1__XX__YY, 'Eq.Math_Addition_Digits__Carry1__XX__YY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__Carry1__XXX__YY, 'Eq.Math_Addition_Digits__Carry1__XXX__YY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__Carry1__XXXX__YY, 'Eq.Math_Addition_Digits__Carry1__XXXX__YY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__Carry1__XXXXX__YY, 'Eq.Math_Addition_Digits__Carry1__XXXXX__YY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__Carry1__XXXXXX__YY, 'Eq.Math_Addition_Digits__Carry1__XXXXXX__YY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__Carry1__X__YYY, 'Eq.Math_Addition_Digits__Carry1__X__YYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__Carry1__XX__YYY, 'Eq.Math_Addition_Digits__Carry1__XX__YYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__Carry1__XXX__YYY, 'Eq.Math_Addition_Digits__Carry1__XXX__YYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__Carry1__XXXX__YYY, 'Eq.Math_Addition_Digits__Carry1__XXXX__YYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__Carry1__XXXXX__YYY, 'Eq.Math_Addition_Digits__Carry1__XXXXX__YYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__Carry1__XXXXXX__YYY, 'Eq.Math_Addition_Digits__Carry1__XXXXXX__YYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__Carry1__X__YYYY, 'Eq.Math_Addition_Digits__Carry1__X__YYYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__Carry1__XX__YYYY, 'Eq.Math_Addition_Digits__Carry1__XX__YYYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__Carry1__XXX__YYYY, 'Eq.Math_Addition_Digits__Carry1__XXX__YYYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__Carry1__XXXX__YYYY, 'Eq.Math_Addition_Digits__Carry1__XXXX__YYYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__Carry1__XXXXX__YYYY, 'Eq.Math_Addition_Digits__Carry1__XXXXX__YYYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__Carry1__XXXXXX__YYYY, 'Eq.Math_Addition_Digits__Carry1__XXXXXX__YYYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__Carry1__X__YYYYY, 'Eq.Math_Addition_Digits__Carry1__X__YYYYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__Carry1__XX__YYYYY, 'Eq.Math_Addition_Digits__Carry1__XX__YYYYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__Carry1__XXX__YYYYY, 'Eq.Math_Addition_Digits__Carry1__XXX__YYYYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__Carry1__XXXX__YYYYY, 'Eq.Math_Addition_Digits__Carry1__XXXX__YYYYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__Carry1__XXXXX__YYYYY, 'Eq.Math_Addition_Digits__Carry1__XXXXX__YYYYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__Carry1__XXXXXX__YYYYY, 'Eq.Math_Addition_Digits__Carry1__XXXXXX__YYYYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__Carry1__X__YYYYYY, 'Eq.Math_Addition_Digits__Carry1__X__YYYYYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__Carry1__XX__YYYYYY, 'Eq.Math_Addition_Digits__Carry1__XX__YYYYYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__Carry1__XXX__YYYYYY, 'Eq.Math_Addition_Digits__Carry1__XXX__YYYYYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__Carry1__XXXX__YYYYYY, 'Eq.Math_Addition_Digits__Carry1__XXXX__YYYYYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__Carry1__XXXXX__YYYYYY, 'Eq.Math_Addition_Digits__Carry1__XXXXX__YYYYYY');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__Carry1__XXXXXX__YYYYYY, 'Eq.Math_Addition_Digits__Carry1__XXXXXX__YYYYYY');

  // Math Addition Digits - Zeros Any
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__CarryAny__XX__Y0, 'Eq.Math_Addition_Digits__CarryAny__XX__Y0');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__CarryAny__XXX__Y0, 'Eq.Math_Addition_Digits__CarryAny__XXX__Y0');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__CarryAny__XXX__Y00, 'Eq.Math_Addition_Digits__CarryAny__XXX__Y00');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__CarryAny__XXXX__Y0, 'Eq.Math_Addition_Digits__CarryAny__XXXX__Y0');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__CarryAny__XXXX__Y00, 'Eq.Math_Addition_Digits__CarryAny__XXXX__Y00');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__CarryAny__XXXX__Y000, 'Eq.Math_Addition_Digits__CarryAny__XXXX__Y000');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__CarryAny__XXXXX__Y0, 'Eq.Math_Addition_Digits__CarryAny__XXXXX__Y0');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__CarryAny__XXXXX__Y00, 'Eq.Math_Addition_Digits__CarryAny__XXXXX__Y00');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__CarryAny__XXXXX__Y000, 'Eq.Math_Addition_Digits__CarryAny__XXXXX__Y000');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__CarryAny__XXXXX__Y0000, 'Eq.Math_Addition_Digits__CarryAny__XXXXX__Y0000');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__CarryAny__XXXXXX__Y0, 'Eq.Math_Addition_Digits__CarryAny__XXXXXX__Y0');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__CarryAny__XXXXXX__Y00, 'Eq.Math_Addition_Digits__CarryAny__XXXXXX__Y00');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__CarryAny__XXXXXX__Y000, 'Eq.Math_Addition_Digits__CarryAny__XXXXXX__Y000');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__CarryAny__XXXXXX__Y0000, 'Eq.Math_Addition_Digits__CarryAny__XXXXXX__Y0000');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__CarryAny__XXXXXX__Y00000, 'Eq.Math_Addition_Digits__CarryAny__XXXXXX__Y00000');

  // Math Addition Digits - Zeros WithoutCarry
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__WithoutCarry__XX__Y0, 'Eq.Math_Addition_Digits__WithoutCarry__XX__Y0');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__WithoutCarry__XXX__Y0, 'Eq.Math_Addition_Digits__WithoutCarry__XXX__Y0');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__WithoutCarry__XXX__Y00, 'Eq.Math_Addition_Digits__WithoutCarry__XXX__Y00');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__WithoutCarry__XXXX__Y0, 'Eq.Math_Addition_Digits__WithoutCarry__XXXX__Y0');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__WithoutCarry__XXXX__Y00, 'Eq.Math_Addition_Digits__WithoutCarry__XXXX__Y00');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__WithoutCarry__XXXX__Y000, 'Eq.Math_Addition_Digits__WithoutCarry__XXXX__Y000');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__WithoutCarry__XXXXX__Y0, 'Eq.Math_Addition_Digits__WithoutCarry__XXXXX__Y0');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__WithoutCarry__XXXXX__Y00, 'Eq.Math_Addition_Digits__WithoutCarry__XXXXX__Y00');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__WithoutCarry__XXXXX__Y000, 'Eq.Math_Addition_Digits__WithoutCarry__XXXXX__Y000');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__WithoutCarry__XXXXX__Y0000, 'Eq.Math_Addition_Digits__WithoutCarry__XXXXX__Y0000');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__WithoutCarry__XXXXXX__Y0, 'Eq.Math_Addition_Digits__WithoutCarry__XXXXXX__Y0');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__WithoutCarry__XXXXXX__Y00, 'Eq.Math_Addition_Digits__WithoutCarry__XXXXXX__Y00');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__WithoutCarry__XXXXXX__Y000, 'Eq.Math_Addition_Digits__WithoutCarry__XXXXXX__Y000');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__WithoutCarry__XXXXXX__Y0000, 'Eq.Math_Addition_Digits__WithoutCarry__XXXXXX__Y0000');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__WithoutCarry__XXXXXX__Y00000, 'Eq.Math_Addition_Digits__WithoutCarry__XXXXXX__Y00000');

  // Math Addition Digits - Zeros Carry1
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__Carry1__XXX__Y0, 'Eq.Math_Addition_Digits__Carry1__XXX__Y0');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__Carry1__XXXX__Y0, 'Eq.Math_Addition_Digits__Carry1__XXXX__Y0');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__Carry1__XXXX__Y00, 'Eq.Math_Addition_Digits__Carry1__XXXX__Y00');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__Carry1__XXXXX__Y0, 'Eq.Math_Addition_Digits__Carry1__XXXXX__Y0');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__Carry1__XXXXX__Y00, 'Eq.Math_Addition_Digits__Carry1__XXXXX__Y00');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__Carry1__XXXXX__Y000, 'Eq.Math_Addition_Digits__Carry1__XXXXX__Y000');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__Carry1__XXXXXX__Y0, 'Eq.Math_Addition_Digits__Carry1__XXXXXX__Y0');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__Carry1__XXXXXX__Y00, 'Eq.Math_Addition_Digits__Carry1__XXXXXX__Y00');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__Carry1__XXXXXX__Y000, 'Eq.Math_Addition_Digits__Carry1__XXXXXX__Y000');
  builder.add(EGenMode.GenEq, MathAdditionDigits.Math_Addition_Digits__Carry1__XXXXXX__Y0000, 'Eq.Math_Addition_Digits__Carry1__XXXXXX__Y0000');

  // Math Subtraction Digits
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__CarryAny__XX__Y, 'Eq.Math_Subtraction_Digits__CarryAny__XX__Y');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__CarryAny__XXX__Y, 'Eq.Math_Subtraction_Digits__CarryAny__XXX__Y');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__CarryAny__XXXX__Y, 'Eq.Math_Subtraction_Digits__CarryAny__XXXX__Y');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__CarryAny__XXXXX__Y, 'Eq.Math_Subtraction_Digits__CarryAny__XXXXX__Y');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__CarryAny__XXXXXX__Y, 'Eq.Math_Subtraction_Digits__CarryAny__XXXXXX__Y');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__CarryAny__X__YY, 'Eq.Math_Subtraction_Digits__CarryAny__X__YY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__CarryAny__XX__YY, 'Eq.Math_Subtraction_Digits__CarryAny__XX__YY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__CarryAny__XXX__YY, 'Eq.Math_Subtraction_Digits__CarryAny__XXX__YY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__CarryAny__XXXX__YY, 'Eq.Math_Subtraction_Digits__CarryAny__XXXX__YY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__CarryAny__XXXXX__YY, 'Eq.Math_Subtraction_Digits__CarryAny__XXXXX__YY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__CarryAny__XXXXXX__YY, 'Eq.Math_Subtraction_Digits__CarryAny__XXXXXX__YY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__CarryAny__X__YYY, 'Eq.Math_Subtraction_Digits__CarryAny__X__YYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__CarryAny__XX__YYY, 'Eq.Math_Subtraction_Digits__CarryAny__XX__YYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__CarryAny__XXX__YYY, 'Eq.Math_Subtraction_Digits__CarryAny__XXX__YYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__CarryAny__XXXX__YYY, 'Eq.Math_Subtraction_Digits__CarryAny__XXXX__YYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__CarryAny__XXXXX__YYY, 'Eq.Math_Subtraction_Digits__CarryAny__XXXXX__YYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__CarryAny__XXXXXX__YYY, 'Eq.Math_Subtraction_Digits__CarryAny__XXXXXX__YYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__CarryAny__X__YYYY, 'Eq.Math_Subtraction_Digits__CarryAny__X__YYYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__CarryAny__XX__YYYY, 'Eq.Math_Subtraction_Digits__CarryAny__XX__YYYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__CarryAny__XXX__YYYY, 'Eq.Math_Subtraction_Digits__CarryAny__XXX__YYYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__CarryAny__XXXX__YYYY, 'Eq.Math_Subtraction_Digits__CarryAny__XXXX__YYYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__CarryAny__XXXXX__YYYY, 'Eq.Math_Subtraction_Digits__CarryAny__XXXXX__YYYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__CarryAny__XXXXXX__YYYY, 'Eq.Math_Subtraction_Digits__CarryAny__XXXXXX__YYYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__CarryAny__X__YYYYY, 'Eq.Math_Subtraction_Digits__CarryAny__X__YYYYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__CarryAny__XX__YYYYY, 'Eq.Math_Subtraction_Digits__CarryAny__XX__YYYYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__CarryAny__XXX__YYYYY, 'Eq.Math_Subtraction_Digits__CarryAny__XXX__YYYYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__CarryAny__XXXX__YYYYY, 'Eq.Math_Subtraction_Digits__CarryAny__XXXX__YYYYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__CarryAny__XXXXX__YYYYY, 'Eq.Math_Subtraction_Digits__CarryAny__XXXXX__YYYYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__CarryAny__XXXXXX__YYYYY, 'Eq.Math_Subtraction_Digits__CarryAny__XXXXXX__YYYYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__CarryAny__X__YYYYYY, 'Eq.Math_Subtraction_Digits__CarryAny__X__YYYYYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__CarryAny__XX__YYYYYY, 'Eq.Math_Subtraction_Digits__CarryAny__XX__YYYYYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__CarryAny__XXX__YYYYYY, 'Eq.Math_Subtraction_Digits__CarryAny__XXX__YYYYYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__CarryAny__XXXX__YYYYYY, 'Eq.Math_Subtraction_Digits__CarryAny__XXXX__YYYYYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__CarryAny__XXXXX__YYYYYY, 'Eq.Math_Subtraction_Digits__CarryAny__XXXXX__YYYYYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__CarryAny__XXXXXX__YYYYYY, 'Eq.Math_Subtraction_Digits__CarryAny__XXXXXX__YYYYYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__CarryAll__XX__Y, 'Eq.Math_Subtraction_Digits__CarryAll__XX__Y');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__CarryAll__XXX__Y, 'Eq.Math_Subtraction_Digits__CarryAll__XXX__Y');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__CarryAll__XXXX__Y, 'Eq.Math_Subtraction_Digits__CarryAll__XXXX__Y');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__CarryAll__XXXXX__Y, 'Eq.Math_Subtraction_Digits__CarryAll__XXXXX__Y');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__CarryAll__XXXXXX__Y, 'Eq.Math_Subtraction_Digits__CarryAll__XXXXXX__Y');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__CarryAll__X__YY, 'Eq.Math_Subtraction_Digits__CarryAll__X__YY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__CarryAll__XX__YY, 'Eq.Math_Subtraction_Digits__CarryAll__XX__YY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__CarryAll__XXX__YY, 'Eq.Math_Subtraction_Digits__CarryAll__XXX__YY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__CarryAll__XXXX__YY, 'Eq.Math_Subtraction_Digits__CarryAll__XXXX__YY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__CarryAll__XXXXX__YY, 'Eq.Math_Subtraction_Digits__CarryAll__XXXXX__YY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__CarryAll__XXXXXX__YY, 'Eq.Math_Subtraction_Digits__CarryAll__XXXXXX__YY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__CarryAll__X__YYY, 'Eq.Math_Subtraction_Digits__CarryAll__X__YYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__CarryAll__XX__YYY, 'Eq.Math_Subtraction_Digits__CarryAll__XX__YYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__CarryAll__XXX__YYY, 'Eq.Math_Subtraction_Digits__CarryAll__XXX__YYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__CarryAll__XXXX__YYY, 'Eq.Math_Subtraction_Digits__CarryAll__XXXX__YYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__CarryAll__XXXXX__YYY, 'Eq.Math_Subtraction_Digits__CarryAll__XXXXX__YYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__CarryAll__XXXXXX__YYY, 'Eq.Math_Subtraction_Digits__CarryAll__XXXXXX__YYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__CarryAll__X__YYYY, 'Eq.Math_Subtraction_Digits__CarryAll__X__YYYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__CarryAll__XX__YYYY, 'Eq.Math_Subtraction_Digits__CarryAll__XX__YYYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__CarryAll__XXX__YYYY, 'Eq.Math_Subtraction_Digits__CarryAll__XXX__YYYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__CarryAll__XXXX__YYYY, 'Eq.Math_Subtraction_Digits__CarryAll__XXXX__YYYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__CarryAll__XXXXX__YYYY, 'Eq.Math_Subtraction_Digits__CarryAll__XXXXX__YYYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__CarryAll__XXXXXX__YYYY, 'Eq.Math_Subtraction_Digits__CarryAll__XXXXXX__YYYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__CarryAll__X__YYYYY, 'Eq.Math_Subtraction_Digits__CarryAll__X__YYYYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__CarryAll__XX__YYYYY, 'Eq.Math_Subtraction_Digits__CarryAll__XX__YYYYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__CarryAll__XXX__YYYYY, 'Eq.Math_Subtraction_Digits__CarryAll__XXX__YYYYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__CarryAll__XXXX__YYYYY, 'Eq.Math_Subtraction_Digits__CarryAll__XXXX__YYYYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__CarryAll__XXXXX__YYYYY, 'Eq.Math_Subtraction_Digits__CarryAll__XXXXX__YYYYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__CarryAll__XXXXXX__YYYYY, 'Eq.Math_Subtraction_Digits__CarryAll__XXXXXX__YYYYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__CarryAll__X__YYYYYY, 'Eq.Math_Subtraction_Digits__CarryAll__X__YYYYYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__CarryAll__XX__YYYYYY, 'Eq.Math_Subtraction_Digits__CarryAll__XX__YYYYYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__CarryAll__XXX__YYYYYY, 'Eq.Math_Subtraction_Digits__CarryAll__XXX__YYYYYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__CarryAll__XXXX__YYYYYY, 'Eq.Math_Subtraction_Digits__CarryAll__XXXX__YYYYYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__CarryAll__XXXXX__YYYYYY, 'Eq.Math_Subtraction_Digits__CarryAll__XXXXX__YYYYYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__CarryAll__XXXXXX__YYYYYY, 'Eq.Math_Subtraction_Digits__CarryAll__XXXXXX__YYYYYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__WithoutCarry__XX__Y, 'Eq.Math_Subtraction_Digits__WithoutCarry__XX__Y');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__WithoutCarry__XXX__Y, 'Eq.Math_Subtraction_Digits__WithoutCarry__XXX__Y');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__WithoutCarry__XXXX__Y, 'Eq.Math_Subtraction_Digits__WithoutCarry__XXXX__Y');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__WithoutCarry__XXXXX__Y, 'Eq.Math_Subtraction_Digits__WithoutCarry__XXXXX__Y');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__WithoutCarry__XXXXXX__Y, 'Eq.Math_Subtraction_Digits__WithoutCarry__XXXXXX__Y');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__WithoutCarry__X__YY, 'Eq.Math_Subtraction_Digits__WithoutCarry__X__YY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__WithoutCarry__XX__YY, 'Eq.Math_Subtraction_Digits__WithoutCarry__XX__YY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__WithoutCarry__XXX__YY, 'Eq.Math_Subtraction_Digits__WithoutCarry__XXX__YY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__WithoutCarry__XXXX__YY, 'Eq.Math_Subtraction_Digits__WithoutCarry__XXXX__YY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__WithoutCarry__XXXXX__YY, 'Eq.Math_Subtraction_Digits__WithoutCarry__XXXXX__YY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__WithoutCarry__XXXXXX__YY, 'Eq.Math_Subtraction_Digits__WithoutCarry__XXXXXX__YY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__WithoutCarry__X__YYY, 'Eq.Math_Subtraction_Digits__WithoutCarry__X__YYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__WithoutCarry__XX__YYY, 'Eq.Math_Subtraction_Digits__WithoutCarry__XX__YYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__WithoutCarry__XXX__YYY, 'Eq.Math_Subtraction_Digits__WithoutCarry__XXX__YYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__WithoutCarry__XXXX__YYY, 'Eq.Math_Subtraction_Digits__WithoutCarry__XXXX__YYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__WithoutCarry__XXXXX__YYY, 'Eq.Math_Subtraction_Digits__WithoutCarry__XXXXX__YYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__WithoutCarry__XXXXXX__YYY, 'Eq.Math_Subtraction_Digits__WithoutCarry__XXXXXX__YYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__WithoutCarry__X__YYYY, 'Eq.Math_Subtraction_Digits__WithoutCarry__X__YYYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__WithoutCarry__XX__YYYY, 'Eq.Math_Subtraction_Digits__WithoutCarry__XX__YYYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__WithoutCarry__XXX__YYYY, 'Eq.Math_Subtraction_Digits__WithoutCarry__XXX__YYYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__WithoutCarry__XXXX__YYYY, 'Eq.Math_Subtraction_Digits__WithoutCarry__XXXX__YYYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__WithoutCarry__XXXXX__YYYY, 'Eq.Math_Subtraction_Digits__WithoutCarry__XXXXX__YYYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__WithoutCarry__XXXXXX__YYYY, 'Eq.Math_Subtraction_Digits__WithoutCarry__XXXXXX__YYYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__WithoutCarry__X__YYYYY, 'Eq.Math_Subtraction_Digits__WithoutCarry__X__YYYYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__WithoutCarry__XX__YYYYY, 'Eq.Math_Subtraction_Digits__WithoutCarry__XX__YYYYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__WithoutCarry__XXX__YYYYY, 'Eq.Math_Subtraction_Digits__WithoutCarry__XXX__YYYYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__WithoutCarry__XXXX__YYYYY, 'Eq.Math_Subtraction_Digits__WithoutCarry__XXXX__YYYYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__WithoutCarry__XXXXX__YYYYY, 'Eq.Math_Subtraction_Digits__WithoutCarry__XXXXX__YYYYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__WithoutCarry__XXXXXX__YYYYY, 'Eq.Math_Subtraction_Digits__WithoutCarry__XXXXXX__YYYYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__WithoutCarry__X__YYYYYY, 'Eq.Math_Subtraction_Digits__WithoutCarry__X__YYYYYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__WithoutCarry__XX__YYYYYY, 'Eq.Math_Subtraction_Digits__WithoutCarry__XX__YYYYYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__WithoutCarry__XXX__YYYYYY, 'Eq.Math_Subtraction_Digits__WithoutCarry__XXX__YYYYYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__WithoutCarry__XXXX__YYYYYY, 'Eq.Math_Subtraction_Digits__WithoutCarry__XXXX__YYYYYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__WithoutCarry__XXXXX__YYYYYY, 'Eq.Math_Subtraction_Digits__WithoutCarry__XXXXX__YYYYYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__WithoutCarry__XXXXXX__YYYYYY, 'Eq.Math_Subtraction_Digits__WithoutCarry__XXXXXX__YYYYYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__Carry1__XX__Y, 'Eq.Math_Subtraction_Digits__Carry1__XX__Y');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__Carry1__XXX__Y, 'Eq.Math_Subtraction_Digits__Carry1__XXX__Y');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__Carry1__XXXX__Y, 'Eq.Math_Subtraction_Digits__Carry1__XXXX__Y');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__Carry1__XXXXX__Y, 'Eq.Math_Subtraction_Digits__Carry1__XXXXX__Y');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__Carry1__XXXXXX__Y, 'Eq.Math_Subtraction_Digits__Carry1__XXXXXX__Y');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__Carry1__X__YY, 'Eq.Math_Subtraction_Digits__Carry1__X__YY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__Carry1__XX__YY, 'Eq.Math_Subtraction_Digits__Carry1__XX__YY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__Carry1__XXX__YY, 'Eq.Math_Subtraction_Digits__Carry1__XXX__YY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__Carry1__XXXX__YY, 'Eq.Math_Subtraction_Digits__Carry1__XXXX__YY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__Carry1__XXXXX__YY, 'Eq.Math_Subtraction_Digits__Carry1__XXXXX__YY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__Carry1__XXXXXX__YY, 'Eq.Math_Subtraction_Digits__Carry1__XXXXXX__YY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__Carry1__X__YYY, 'Eq.Math_Subtraction_Digits__Carry1__X__YYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__Carry1__XX__YYY, 'Eq.Math_Subtraction_Digits__Carry1__XX__YYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__Carry1__XXX__YYY, 'Eq.Math_Subtraction_Digits__Carry1__XXX__YYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__Carry1__XXXX__YYY, 'Eq.Math_Subtraction_Digits__Carry1__XXXX__YYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__Carry1__XXXXX__YYY, 'Eq.Math_Subtraction_Digits__Carry1__XXXXX__YYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__Carry1__XXXXXX__YYY, 'Eq.Math_Subtraction_Digits__Carry1__XXXXXX__YYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__Carry1__X__YYYY, 'Eq.Math_Subtraction_Digits__Carry1__X__YYYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__Carry1__XX__YYYY, 'Eq.Math_Subtraction_Digits__Carry1__XX__YYYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__Carry1__XXX__YYYY, 'Eq.Math_Subtraction_Digits__Carry1__XXX__YYYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__Carry1__XXXX__YYYY, 'Eq.Math_Subtraction_Digits__Carry1__XXXX__YYYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__Carry1__XXXXX__YYYY, 'Eq.Math_Subtraction_Digits__Carry1__XXXXX__YYYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__Carry1__XXXXXX__YYYY, 'Eq.Math_Subtraction_Digits__Carry1__XXXXXX__YYYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__Carry1__X__YYYYY, 'Eq.Math_Subtraction_Digits__Carry1__X__YYYYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__Carry1__XX__YYYYY, 'Eq.Math_Subtraction_Digits__Carry1__XX__YYYYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__Carry1__XXX__YYYYY, 'Eq.Math_Subtraction_Digits__Carry1__XXX__YYYYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__Carry1__XXXX__YYYYY, 'Eq.Math_Subtraction_Digits__Carry1__XXXX__YYYYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__Carry1__XXXXX__YYYYY, 'Eq.Math_Subtraction_Digits__Carry1__XXXXX__YYYYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__Carry1__XXXXXX__YYYYY, 'Eq.Math_Subtraction_Digits__Carry1__XXXXXX__YYYYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__Carry1__X__YYYYYY, 'Eq.Math_Subtraction_Digits__Carry1__X__YYYYYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__Carry1__XX__YYYYYY, 'Eq.Math_Subtraction_Digits__Carry1__XX__YYYYYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__Carry1__XXX__YYYYYY, 'Eq.Math_Subtraction_Digits__Carry1__XXX__YYYYYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__Carry1__XXXX__YYYYYY, 'Eq.Math_Subtraction_Digits__Carry1__XXXX__YYYYYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__Carry1__XXXXX__YYYYYY, 'Eq.Math_Subtraction_Digits__Carry1__XXXXX__YYYYYY');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__Carry1__XXXXXX__YYYYYY, 'Eq.Math_Subtraction_Digits__Carry1__XXXXXX__YYYYYY');

  // Math Subtraction Digits - Zeros Any
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__CarryAny__XX__Y0, 'Eq.Math_Subtraction_Digits__CarryAny__XX__Y0');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__CarryAny__XXX__Y0, 'Eq.Math_Subtraction_Digits__CarryAny__XXX__Y0');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__CarryAny__XXX__Y00, 'Eq.Math_Subtraction_Digits__CarryAny__XXX__Y00');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__CarryAny__XXXX__Y0, 'Eq.Math_Subtraction_Digits__CarryAny__XXXX__Y0');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__CarryAny__XXXX__Y00, 'Eq.Math_Subtraction_Digits__CarryAny__XXXX__Y00');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__CarryAny__XXXX__Y000, 'Eq.Math_Subtraction_Digits__CarryAny__XXXX__Y000');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__CarryAny__XXXXX__Y0, 'Eq.Math_Subtraction_Digits__CarryAny__XXXXX__Y0');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__CarryAny__XXXXX__Y00, 'Eq.Math_Subtraction_Digits__CarryAny__XXXXX__Y00');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__CarryAny__XXXXX__Y000, 'Eq.Math_Subtraction_Digits__CarryAny__XXXXX__Y000');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__CarryAny__XXXXX__Y0000, 'Eq.Math_Subtraction_Digits__CarryAny__XXXXX__Y0000');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__CarryAny__XXXXXX__Y0, 'Eq.Math_Subtraction_Digits__CarryAny__XXXXXX__Y0');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__CarryAny__XXXXXX__Y00, 'Eq.Math_Subtraction_Digits__CarryAny__XXXXXX__Y00');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__CarryAny__XXXXXX__Y000, 'Eq.Math_Subtraction_Digits__CarryAny__XXXXXX__Y000');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__CarryAny__XXXXXX__Y0000, 'Eq.Math_Subtraction_Digits__CarryAny__XXXXXX__Y0000');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__CarryAny__XXXXXX__Y00000, 'Eq.Math_Subtraction_Digits__CarryAny__XXXXXX__Y00000');

  // Math Subtraction Digits - Zeros WithoutCarry
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__WithoutCarry__XX__Y0, 'Eq.Math_Subtraction_Digits__WithoutCarry__XX__Y0');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__WithoutCarry__XXX__Y0, 'Eq.Math_Subtraction_Digits__WithoutCarry__XXX__Y0');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__WithoutCarry__XXX__Y00, 'Eq.Math_Subtraction_Digits__WithoutCarry__XXX__Y00');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__WithoutCarry__XXXX__Y0, 'Eq.Math_Subtraction_Digits__WithoutCarry__XXXX__Y0');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__WithoutCarry__XXXX__Y00, 'Eq.Math_Subtraction_Digits__WithoutCarry__XXXX__Y00');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__WithoutCarry__XXXX__Y000, 'Eq.Math_Subtraction_Digits__WithoutCarry__XXXX__Y000');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__WithoutCarry__XXXXX__Y0, 'Eq.Math_Subtraction_Digits__WithoutCarry__XXXXX__Y0');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__WithoutCarry__XXXXX__Y00, 'Eq.Math_Subtraction_Digits__WithoutCarry__XXXXX__Y00');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__WithoutCarry__XXXXX__Y000, 'Eq.Math_Subtraction_Digits__WithoutCarry__XXXXX__Y000');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__WithoutCarry__XXXXX__Y0000, 'Eq.Math_Subtraction_Digits__WithoutCarry__XXXXX__Y0000');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__WithoutCarry__XXXXXX__Y0, 'Eq.Math_Subtraction_Digits__WithoutCarry__XXXXXX__Y0');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__WithoutCarry__XXXXXX__Y00, 'Eq.Math_Subtraction_Digits__WithoutCarry__XXXXXX__Y00');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__WithoutCarry__XXXXXX__Y000, 'Eq.Math_Subtraction_Digits__WithoutCarry__XXXXXX__Y000');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__WithoutCarry__XXXXXX__Y0000, 'Eq.Math_Subtraction_Digits__WithoutCarry__XXXXXX__Y0000');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__WithoutCarry__XXXXXX__Y00000, 'Eq.Math_Subtraction_Digits__WithoutCarry__XXXXXX__Y00000');

  // Math Subtraction Digits - Zeros Carry1
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__Carry1__XXX__Y0, 'Eq.Math_Subtraction_Digits__Carry1__XXX__Y0');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__Carry1__XXXX__Y0, 'Eq.Math_Subtraction_Digits__Carry1__XXXX__Y0');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__Carry1__XXXX__Y00, 'Eq.Math_Subtraction_Digits__Carry1__XXXX__Y00');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__Carry1__XXXXX__Y0, 'Eq.Math_Subtraction_Digits__Carry1__XXXXX__Y0');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__Carry1__XXXXX__Y00, 'Eq.Math_Subtraction_Digits__Carry1__XXXXX__Y00');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__Carry1__XXXXX__Y000, 'Eq.Math_Subtraction_Digits__Carry1__XXXXX__Y000');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__Carry1__XXXXXX__Y0, 'Eq.Math_Subtraction_Digits__Carry1__XXXXXX__Y0');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__Carry1__XXXXXX__Y00, 'Eq.Math_Subtraction_Digits__Carry1__XXXXXX__Y00');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__Carry1__XXXXXX__Y000, 'Eq.Math_Subtraction_Digits__Carry1__XXXXXX__Y000');
  builder.add(EGenMode.GenEq, MathSubtractionDigits.Math_Subtraction_Digits__Carry1__XXXXXX__Y0000, 'Eq.Math_Subtraction_Digits__Carry1__XXXXXX__Y0000');
}
